import React, { useState } from "react";
import { Grid, Box, Button, Link, Typography, IconButton } from "@mui/material";
import RegularizationAccordion from "@/pages/attendance/component/Accordion";
import HistoryRegularizePng from "@/assets/images/attendance/HistoryRegularize.png";
import renderActions from "@/pages/attendance/component/RenderActions";
import DetailRow from "@/pages/attendance/component/DetailRow";
import DisplayDates from "@/pages/attendance/component/DisplayDates";
import { ArrowBackIosNewOutlinedIcon } from "@/icons";
import ViewRegularizationList from "@/pages/attendance/views/regularization/ViewRegularizationList/ViewRegularizationList";
import Loader from "@/components/loader";

const HistoryRegularize = ({ regularizationRecords, refetchHistory, isLoadingHistory }) => {
  const [showViewList, setShowViewList] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const regRecords = regularizationRecords || []

  const formatDate = (dateString) => {
    return new Date(dateString)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .split("/")
      .join("/");
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "REG":
        return "Regularization";
      case "WFH":
        return "Work From Home";
      case "OD":
        return "On Duty";
      default:
        return "";
    }
  };

  const renderDetails = (item) => {
  const workTypes = item.appliedRegularizations
    ?.map((reg) => getStatusLabel(reg?.regularizationStatus))
    .filter((type) => type && type.trim() !== "") // remove null or empty
    .join(", ");

    return (
      <Grid container spacing={2}>
        <DetailRow label="Work Type" value={workTypes} />
        <DetailRow label="Applied On" value={formatDate(item.appliedDate)} />
        <DetailRow label="No. of days" value={item.noOfDays} />
        <DetailRow
          label="Applied For"
          value={<DisplayDates dates={item.regularizationDates} />}
        />
      </Grid>
    );
  };

  const actions = (item) => [
    {
      label: "View",
      variant: "outlined",
      sx: {
        /* additional styles */
        backgroundColor: (theme) =>
          theme.palette.BudgieThemeColor.Primary[1200],
        color: (theme) => theme.palette.BudgieThemeColor.BaseWhite,
        p: (theme) => theme.spacing(1, 2),
        m: (theme) => theme.spacing(0, 1),
        borderRadius: (theme) => theme.shape.s,
      },
      hoverSx: {
        /* additional styles */
        backgroundColor: (theme) =>
          theme.palette.BudgieThemeColor.Primary[1200],
        color: (theme) => theme.palette.BudgieThemeColor.BaseWhite,
        borderColor: (theme) => theme.palette.BudgieThemeColor.Primary[600],
      },
      onclick: () => {
        setShowViewList(true);
        setSelectedRecord(item);
      },
    },
  ];

  return (
    <>
      {isLoadingHistory ? (
        <Loader />
      ) : (
        <>
          {showViewList ? (
            <>
              <Typography variant="h4">
                <IconButton
                  component={Link}
                  to="/attendance/regularization"
                  color="primary"
                  onClick={() => setShowViewList(false)}
                >
                  <ArrowBackIosNewOutlinedIcon />
                </IconButton>
                Review Regularizations
              </Typography>
              {/* <Button
            variant="contained"
            color="primary"
            onClick={() => setShowViewList(false)}
          >
            Back
          </Button>
          <Typography variant="h5">Regularization withdrawn</Typography> */}
              <ViewRegularizationList setShowViewList={setShowViewList} selectedRecord={selectedRecord} refetchHistory={refetchHistory} />
            </>
          ) : (
            <Grid container>
              <Grid item lg={8}>
                <RegularizationAccordion
                  showChip={true}
                  items={regRecords}
                  renderDetails={renderDetails}
                  renderActions={(item) => renderActions(item, actions(item))}
                  detailsGridProps={{ xs: 12, sm: 9 }}
                  containerSpacing={(theme) => theme.spacing(2)}
                  actionsGridProps={{ xs: 12, sm: 3 }}
                  accordionProps={{ elevation: 1 }}
                  getTitle={(item) => `Applied on :${formatDate(item.appliedDate)}`}
                  showActions={true}
                  getChipLabel={(item) => item.status}
                  getChipStyle={(item) => {
                    switch (item.status) {
                      case "Approved":
                        return {
                          backgroundColor: "#ECFDF3",
                          color: "#1DA850",
                          borderColor: "#A9D9BD",
                        };
                      case "Partially Approved":
                        return {
                          backgroundColor: "#ECFDF3",
                          color: "#1DA850",
                          borderColor: "#A9D9BD",
                        };
                      case "Rejected":
                        return {
                          backgroundColor: "#FEF3F2",
                          color: "#EC2424",
                          borderColor: "#F9B4B4",
                        };
                      case "Withdraw":
                        return {
                          backgroundColor: "#FFFBEA",
                          color: "#D47F00",
                          borderColor: "#FFD88D",
                        };
                      default:
                        return {};
                    }
                  }}
                />
              </Grid>
              <Grid
                item
                lg={4}
                display={{ xs: "none", lg: "flex" }}
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
              >
                <Box>
                  <img src={HistoryRegularizePng} alt="History Regularize" />
                </Box>
              </Grid>
            </Grid>
          )}
        </>
      )}
    </>
  );
};

export default HistoryRegularize;
